module.exports = __webpack_public_path__ + "static/img/4.1e45b4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/zh/4.png
// module id = qIeQ
// module chunks = 0